module.exports = __webpack_public_path__ + "img/foxy-fm.25b02235.png";